export default __webpack_public_path__ + "static/victory_point_logo-544c89520048f4cb8648ea19d1ef16dd.svg";